﻿import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';

export class WorkItemNotFoundDialog implements IDialog {
    options: IDialogOptions;
    private $dialogContent: JQuery;

    constructor(resources: IResourceProvider, private closeAction: () => void) {
        this.options = {
            title: resources.getCoreString('WorkItemNotFoundDialogTitle'),
            width: 500,
            height: 300,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('XamlClose'), click: () => this.close() }
            ],
        };    

        this.$dialogContent = $('<div />').text(resources.getCoreString('WorkItemNotFoundDialogText'));
    }

    private close() {
        this.$dialogContent.dialog('close');
        this.closeAction();
    }

    content() {
        return this.$dialogContent;
    }
}